var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrk14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wrk-14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 153.967,
    height: 88.869,
    viewBox: "0 0 153.967 88.869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11139",
    "data-name": "Path 11139",
    d: "M23.3,9.823v8.023a14.887,14.887,0,0,0,.133,2.163H15.1q-1.243,0-3.022-.059c-1.177-.038-2.4-.121-3.633-.245a19.557,19.557,0,0,1-3.318-.6c-.218-.079-.519-.178-.9-.3q-.554-.171-1.107-.382t-.865-.354l-.815-.035L0,23.525l.3.139a10.25,10.25,0,0,0,1.089.409q.675.222,1.409.426c.486.137.915.254,1.3.353a36.328,36.328,0,0,0,5.8.895c1.71.107,3.463.161,5.209.161H24.51a26.437,26.437,0,0,0,3.26-.177,9.689,9.689,0,0,0,2.346-.549l.14-.055.246-.492-.03-.136a8.346,8.346,0,0,1-.151-1.328q-.044-.865-.057-1.759c-.01-.6-.014-1.088-.014-1.474V9.2Z",
    transform: "translate(0 -9.204)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 4.766,
    x2: 0.033,
    y2: 4.766,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#041030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#192c62"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11140",
    "data-name": "Path 11140",
    d: "M12.921,28.146a2.785,2.785,0,0,0-.906,2.215,2.868,2.868,0,0,0,.9,2.255,3.245,3.245,0,0,0,4.229,0,2.893,2.893,0,0,0,.885-2.252,2.809,2.809,0,0,0-.888-2.212,3.059,3.059,0,0,0-2.091-.766,3.148,3.148,0,0,0-2.132.763",
    transform: "translate(-12.015 -27.383)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2.01,
    y1: 10.192,
    x2: -1.843,
    y2: 10.192,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11141",
    "data-name": "Path 11141",
    d: "M33.424,6.589v19.34h6.945V10.9q0-.577.014-1.386c.01-.536.029-1.065.058-1.582a7.9,7.9,0,0,1,.15-1.244l.03-.137-.3-.6Z",
    transform: "translate(-33.424 -5.95)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -4.674,
    y1: 4.148,
    x2: -4.534,
    y2: 4.148,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11142",
    "data-name": "Path 11142",
    d: "M35.662,0a4.693,4.693,0,0,0-2.439.58,7.5,7.5,0,0,0-1.717,1.439l-.226.252L33.3,4.738h.675l.109-.089a3.9,3.9,0,0,1,1.493-.835c.089-.019.177-.038.268-.055a5.932,5.932,0,0,0,1.2.685,4.153,4.153,0,0,0,1.668.323,4.8,4.8,0,0,0,2.451-.577,7.177,7.177,0,0,0,1.705-1.413l.222-.249L41.078.029h-.666l-.1.076a6.133,6.133,0,0,1-1.159.7,4.656,4.656,0,0,1-.585.213A7.112,7.112,0,0,0,37.626.45,4.284,4.284,0,0,0,35.662,0Z",
    transform: "translate(-31.28)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -2.666,
    y1: 18.642,
    x2: -2.581,
    y2: 18.642,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11143",
    "data-name": "Path 11143",
    d: "M56.918,3.707V21.488a24.985,24.985,0,0,1-.158,2.758,17.728,17.728,0,0,1-.454,2.545c-.052.2-.109.39-.167.563l-.032.013a2.48,2.48,0,0,1-.886.117,6.944,6.944,0,0,1-2.608-.594,6.627,6.627,0,0,1-2.549-1.937l-.119-.141h-.8l-2.157,5.457.142.178a9.325,9.325,0,0,0,1.5,1.516A7.544,7.544,0,0,0,53.361,33.5a10.865,10.865,0,0,0,5.453-1.345,9.288,9.288,0,0,0,3.714-4.089,11.477,11.477,0,0,0,.782-2.118H151.27l1.956-5.015.027-.884h-7.481a2.133,2.133,0,0,1-1.39-.348,1,1,0,0,1-.364-.769,1.791,1.791,0,0,1,.625-1.218,12.582,12.582,0,0,1,2.026-1.559q1.345-.868,3.2-2L150.12,14l-1.548-5.8h-.747l-.086.044a49.408,49.408,0,0,0-5.05,2.943,18.527,18.527,0,0,0-3.029,2.481,7.1,7.1,0,0,0-1.489,2.219,5.945,5.945,0,0,0-.4,2.116,5.3,5.3,0,0,0,.4,2.046H120.435V9.361l-6.944.619v7.906a14.9,14.9,0,0,0,.132,2.163h-2.249V10.291l-6.945.618v6.977a14.647,14.647,0,0,0,.134,2.163h-2.25v-8.83l-6.946.619v6.048a14.786,14.786,0,0,0,.134,2.163H83.2V9.244l-6.944.619v8.023a14.8,14.8,0,0,0,.133,2.163H63.862V3.088Z",
    transform: "translate(-46.987 -3.088)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.445,
    y1: 2.82,
    x2: -0.436,
    y2: 2.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11144",
    "data-name": "Path 11144",
    d: "M138.315,4.2a2.824,2.824,0,0,0-.9,2.243,2.838,2.838,0,0,0,.9,2.226,3.247,3.247,0,0,0,4.228,0,2.854,2.854,0,0,0,.886-2.223,2.842,2.842,0,0,0-.889-2.24,3.291,3.291,0,0,0-4.222,0",
    transform: "translate(-137.41 -3.434)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -22.99,
    y1: 14.2,
    x2: -22.823,
    y2: 14.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11145",
    "data-name": "Path 11145",
    d: "M4.728,37.011a7.692,7.692,0,0,0-3.411,2.8A7.421,7.421,0,0,0,.154,43.919,7.8,7.8,0,0,0,1.2,47.974,6.957,6.957,0,0,0,4.306,50.7a11.838,11.838,0,0,0,5.035.956,19.118,19.118,0,0,0,3.069-.225,12.217,12.217,0,0,0,2.365-.6l.254-.1V43.246h-5.1v4.166a4.464,4.464,0,0,1-.5.025A4.076,4.076,0,0,1,7.475,47a3.078,3.078,0,0,1-1.246-1.2A3.574,3.574,0,0,1,5.787,44a3.417,3.417,0,0,1,1.069-2.7,5.3,5.3,0,0,1,3.562-.977,10.9,10.9,0,0,1,1.807.145,5.15,5.15,0,0,1,1.257.338l.829.037V36.621l-.254-.1a7.879,7.879,0,0,0-1.552-.351,15.841,15.841,0,0,0-2.312-.154,13.422,13.422,0,0,0-5.466.992",
    transform: "translate(-0.154 -36.019)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -0.01,
    y1: 3.364,
    x2: 0.057,
    y2: 3.364,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11146",
    "data-name": "Path 11146",
    d: "M26.447,36.257v5.429H22.21V36.257H16.667V51.418H22.21V46.149h4.237v5.269h5.544V36.257Z",
    transform: "translate(-16.667 -36.257)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -1.095,
    y1: 3.454,
    x2: -1.029,
    y2: 3.454,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11147",
    "data-name": "Path 11147",
    d: "M40.066,41.911a2.08,2.08,0,0,1,.335-.875,1.347,1.347,0,0,1,.64-.462,3.955,3.955,0,0,1,1.417-.173c-.023.277-.034.572-.034.883v2.64H39.693Zm.246-5.63a8.375,8.375,0,0,0-2.589.746,5.15,5.15,0,0,0-1.966,1.683,7.513,7.513,0,0,0-1.131,2.9L32.741,51.42H38.3l.623-3.354h3.5V51.42h5.544V40.325c0-.264,0-.6.012-1.012s.021-.808.043-1.2a5.006,5.006,0,0,1,.113-.886l.02-.083-.11-.586-.261-.053a21.077,21.077,0,0,0-2.162-.295c-.825-.073-1.588-.112-2.267-.112a23.706,23.706,0,0,0-3.046.183",
    transform: "translate(-32.741 -36.098)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -2.138,
    y1: 3.429,
    x2: -2.073,
    y2: 3.429,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11148",
    "data-name": "Path 11148",
    d: "M52.416,36.671a5.507,5.507,0,0,0-2.746,1.9,4.871,4.871,0,0,0-.869,2.872,4.24,4.24,0,0,0,.658,2.362,4.619,4.619,0,0,0,1.993,1.62,11.268,11.268,0,0,0,3.256.842l1.255.158a3.678,3.678,0,0,1,1.279.3.316.316,0,0,1,.172.3.2.2,0,0,1-.108.183,1.837,1.837,0,0,1-.714.216,11.415,11.415,0,0,1-3.328-.08,13.665,13.665,0,0,1-1.755-.417,11.4,11.4,0,0,1-1.342-.5L49.34,46.4v4.341l.257.095a10.245,10.245,0,0,0,1.471.4c.595.121,1.248.223,1.941.3a18.6,18.6,0,0,0,2.109.122,17.54,17.54,0,0,0,2.87-.225,9.28,9.28,0,0,0,2.458-.741,4.432,4.432,0,0,0,1.772-1.458,4.383,4.383,0,0,0-.155-4.838,4.95,4.95,0,0,0-2.068-1.443,11.489,11.489,0,0,0-2.667-.661l-1.167-.16a5.641,5.641,0,0,1-1.689-.409.518.518,0,0,1-.3-.518.7.7,0,0,1,.2-.523,1.686,1.686,0,0,1,.8-.372,7.519,7.519,0,0,1,1.66-.148,11.828,11.828,0,0,1,4.25.771l.81.028V36.78l-.255-.1a10.068,10.068,0,0,0-1.962-.48,16.031,16.031,0,0,0-2.483-.185,14.518,14.518,0,0,0-4.766.652",
    transform: "translate(-48.802 -36.019)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -3.492,
    y1: 3.364,
    x2: -3.42,
    y2: 3.364,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11149",
    "data-name": "Path 11149",
    d: "M63.711,36.257V51.418H75.625V46.956H69.254v-.888h5.114V41.847H69.254V40.718h6.191V36.257Z",
    transform: "translate(-63.711 -36.257)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -5.382,
    y1: 3.454,
    x2: -5.298,
    y2: 3.454,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11150",
    "data-name": "Path 11150",
    d: "M76.926,36.257V51.418H88.839V46.956H82.47v-.888h5.113V41.847H82.47V40.718h6.19V36.257Z",
    transform: "translate(-76.926 -36.257)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -6.499,
    y1: 3.454,
    x2: -6.415,
    y2: 3.454,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11151",
    "data-name": "Path 11151",
    d: "M93.094,36.259,90.139,38.1V51.42h11.379V46.959H95.687v-10.7Z",
    transform: "translate(-90.139 -36.259)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -7.973,
    y1: 3.454,
    x2: -7.885,
    y2: 3.454,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11152",
    "data-name": "Path 11152",
    d: "M113.473,41.911a2.107,2.107,0,0,1,.335-.875,1.355,1.355,0,0,1,.641-.462,3.933,3.933,0,0,1,1.415-.173c-.021.277-.032.572-.032.883v2.64H113.1Zm.246-5.63a8.369,8.369,0,0,0-2.588.746,5.146,5.146,0,0,0-1.967,1.683,7.513,7.513,0,0,0-1.13,2.9l-1.884,9.812h5.56l.622-3.354h3.5V51.42h5.543V40.325c0-.264,0-.6.012-1.012s.022-.808.043-1.2a5.021,5.021,0,0,1,.112-.886l.021-.083-.109-.586-.261-.053a21.156,21.156,0,0,0-2.162-.295c-.826-.073-1.588-.112-2.268-.112a23.706,23.706,0,0,0-3.046.183",
    transform: "translate(-106.149 -36.098)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -6.932,
    y1: 3.429,
    x2: -6.866,
    y2: 3.429,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11153",
    "data-name": "Path 11153",
    d: "M128.643,40.559H130.4a2.256,2.256,0,0,1,1.321.355,1.142,1.142,0,0,1,.44,1.008,2.572,2.572,0,0,1-.234,1.091,1.716,1.716,0,0,1-.718.765,2.83,2.83,0,0,1-1.437.306h-1.131Zm-5.543-4.3V51.419h5.543V48.224h1.312a10.515,10.515,0,0,0,3.228-.458A6.8,6.8,0,0,0,135.6,46.44a5.812,5.812,0,0,0,1.5-2.066,6.555,6.555,0,0,0,.514-2.612,4.949,4.949,0,0,0-1.85-4.028,8.555,8.555,0,0,0-5.452-1.477Z",
    transform: "translate(-123.1 -36.257)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -8.536,
    y1: 3.454,
    x2: -8.466,
    y2: 3.454,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11154",
    "data-name": "Path 11154",
    d: "M144.087,40.559h1.759a2.251,2.251,0,0,1,1.32.355,1.14,1.14,0,0,1,.441,1.008,2.572,2.572,0,0,1-.234,1.091,1.716,1.716,0,0,1-.718.765,2.833,2.833,0,0,1-1.437.306h-1.131Zm-5.543-4.3V51.419h5.543V48.224H145.4a10.52,10.52,0,0,0,3.228-.458,6.79,6.79,0,0,0,2.415-1.326,5.8,5.8,0,0,0,1.5-2.066,6.556,6.556,0,0,0,.515-2.612,4.947,4.947,0,0,0-1.851-4.028,8.551,8.551,0,0,0-5.452-1.477Z",
    transform: "translate(-138.544 -36.257)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -9.606,
    y1: 3.454,
    x2: -9.537,
    y2: 3.454,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11155",
    "data-name": "Path 11155",
    d: "M92.284,3.329l-1.673.915,1.673.915L93.2,6.832l.915-1.674,1.675-.915-1.675-.915L93.2,1.654Z",
    transform: "translate(-90.611 -1.654)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -12.372,
    y1: 12.112,
    x2: -12.233,
    y2: 12.112,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1bb6ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3795d3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11156",
    "data-name": "Path 11156",
    d: "M88.477,10.8l-1.029.563,1.029.563.563,1.03.564-1.03,1.029-.563L89.6,10.8l-.564-1.029Z",
    transform: "translate(-87.448 -9.774)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -19.504,
    y1: 17.786,
    x2: -19.279,
    y2: 17.786,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11157",
    "data-name": "Path 11157",
    d: "M87.12,5.481l-.612.334.612.334.334.61.334-.61.611-.334-.611-.334-.334-.612Z",
    transform: "translate(-86.508 -4.869)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -32.585,
    y1: 31.705,
    x2: -32.206,
    y2: 31.705,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11158",
    "data-name": "Path 11158",
    d: "M113.37,9.936v7.911a14.965,14.965,0,0,0,.126,2.159H111.25V10.252l-6.942.614v6.981a13.968,13.968,0,0,0,.134,2.159h-2.254V11.181l-6.942.615v6.051a13.965,13.965,0,0,0,.134,2.159H83.08v-7.66l-6.942,4.334v1.167a13.967,13.967,0,0,0,.134,2.159H70.8l-4.829,3.011v2.891h44.165l10.172-6.342V9.321Z",
    transform: "translate(-65.974 -9.321)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -1.482,
    y1: 1.854,
    x2: -1.46,
    y2: 1.854,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11159",
    "data-name": "Path 11159",
    d: "M79.611,27.475A2.693,2.693,0,0,0,78.517,29.3a2.542,2.542,0,0,0-.633-1.365,3.062,3.062,0,0,0-2.005-.978,3.121,3.121,0,0,0-2.2.538A2.78,2.78,0,0,0,72.552,29.6a2.873,2.873,0,0,0,.658,2.334,3.1,3.1,0,0,0,2.019,1,3.059,3.059,0,0,0,2.189-.556,2.787,2.787,0,0,0,1.074-1.86,2.584,2.584,0,0,0,.654,1.4,3.234,3.234,0,0,0,4.2.432,2.867,2.867,0,0,0,1.118-2.141,2.807,2.807,0,0,0-.654-2.295,3.037,3.037,0,0,0-2-.977,3.946,3.946,0,0,0-.4-.021,3.037,3.037,0,0,0-1.8.56",
    transform: "translate(-72.528 -26.915)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -5.856,
    y1: 4.926,
    x2: -5.775,
    y2: 4.926,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11160",
    "data-name": "Path 11160",
    d: "M90.139,36.259V38.1l2.955-1.844Z",
    transform: "translate(-90.139 -36.259)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -27.461,
    y1: 15.392,
    x2: -27.156,
    y2: 15.392,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11161",
    "data-name": "Path 11161",
    d: "M50.278,32.777a3.05,3.05,0,0,0,.291.126,7.638,7.638,0,0,0,2.773.465,10.823,10.823,0,0,0,5.452-1.347,9.246,9.246,0,0,0,3.712-4.083,11.8,11.8,0,0,0,.78-2.12h2.79V22.928Z",
    transform: "translate(-50.278 -22.928)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -2.736,
    y1: 3.715,
    x2: -2.68,
    y2: 3.715,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11162",
    "data-name": "Path 11162",
    d: "M26.384,47.633v3.735h5.54V44.182Z",
    transform: "translate(-26.384 -44.182)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -2.733,
    y1: 5.116,
    x2: -2.622,
    y2: 5.116,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11163",
    "data-name": "Path 11163",
    d: "M40.07,41.91a2.111,2.111,0,0,1,.331-.876,1.363,1.363,0,0,1,.638-.464,4.05,4.05,0,0,1,1.419-.166c-.025.276-.032.568-.032.883v2.64H39.691Zm-5.642.733-1.687,8.778h5.564l.622-3.358h3.5v3.358h5.54v-11.1c0-.267.007-.6.015-1.008s.023-.812.039-1.206a5.139,5.139,0,0,1,.118-.883l.016-.087-.11-.583-.26-.055a20.67,20.67,0,0,0-2.16-.292c-.268-.023-.528-.046-.78-.062Z",
    transform: "translate(-32.741 -36.15)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -1.384,
    y1: 2.575,
    x2: -1.338,
    y2: 2.575,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11164",
    "data-name": "Path 11164",
    d: "M52.414,36.67a5.5,5.5,0,0,0-2.742,1.9,4.883,4.883,0,0,0-.868,2.876,4.233,4.233,0,0,0,.654,2.356,4.57,4.57,0,0,0,1.994,1.624,11.23,11.23,0,0,0,3.254.843l1.253.157a3.524,3.524,0,0,1,1.284.307.3.3,0,0,1,.173.3.2.2,0,0,1-.11.181,1.762,1.762,0,0,1-.71.22,11.515,11.515,0,0,1-3.333-.079,14.5,14.5,0,0,1-1.757-.418,10.726,10.726,0,0,1-1.34-.5l-.827-.031v4.341l.252.095a10.9,10.9,0,0,0,1.475.395q.9.189,1.939.307a19.114,19.114,0,0,0,2.111.118,17.559,17.559,0,0,0,2.869-.22,9.6,9.6,0,0,0,2.458-.741,4.516,4.516,0,0,0,1.774-1.457,3.946,3.946,0,0,0,.653-2.285,3.892,3.892,0,0,0-.811-2.554,4.942,4.942,0,0,0-2.064-1.449,11.73,11.73,0,0,0-2.671-.662l-1.166-.158a5.5,5.5,0,0,1-1.687-.41.523.523,0,0,1-.307-.519.692.692,0,0,1,.2-.52,1.682,1.682,0,0,1,.8-.37,7.319,7.319,0,0,1,1.655-.149,11.649,11.649,0,0,1,2.42.237,11.843,11.843,0,0,1,1.836.535l.8.023V36.781l-.252-.095a9.543,9.543,0,0,0-1.962-.481,15.67,15.67,0,0,0-2.482-.189,14.521,14.521,0,0,0-4.768.654",
    transform: "translate(-48.805 -36.016)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -2.173,
    y1: 2.655,
    x2: -2.125,
    y2: 2.655,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11165",
    "data-name": "Path 11165",
    d: "M76.926,36.259V46.393l7.3-4.547H82.472V40.719h3.562l2.624-1.639V36.259Z",
    transform: "translate(-76.926 -36.259)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -4.955,
    y1: 3.554,
    x2: -4.889,
    y2: 3.554,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11166",
    "data-name": "Path 11166",
    d: "M63.711,36.259V51.42h5.24l6.674-4.161v-.3H69.259v-.891h5.113V41.846H69.259V40.719h6.185v-4.46Z",
    transform: "translate(-63.711 -36.259)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -3.135,
    y1: 2.881,
    x2: -3.083,
    y2: 2.881,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1484",
    "data-name": "Rectangle 1484",
    width: 42.638,
    height: 1.291,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -0.623,
    y1: 25.891,
    x2: -0.599,
    y2: 25.891,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11167",
    "data-name": "Path 11167",
    d: "M26.385,57.793c4.327,4.33,15.943.907,19.07,10.567h.916l-.094,10.214-.054,0a1.386,1.386,0,0,0-1.383,1.379L44.834,88.5l5.525-.013.006-8.53a1.384,1.384,0,0,0-1.381-1.38h-.052l.093-10.213h.916c3.141-9.654,14.754-6.213,19.086-10.535V56.534l-21.318-.018L26.389,56.5Z",
    transform: "translate(-26.385 -56.499)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -0.623,
    y1: 1,
    x2: -0.599,
    y2: 1,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3450",
    "data-name": "Group 3450",
    transform: "translate(0 9.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3449",
    "data-name": "Group 3449",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1455",
    "data-name": "Rectangle 1455",
    width: 30.502,
    height: 16.704,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3452",
    "data-name": "Group 3452",
    transform: "translate(12.094 27.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3451",
    "data-name": "Group 3451",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1456",
    "data-name": "Rectangle 1456",
    width: 6.016,
    height: 6.015,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3454",
    "data-name": "Group 3454",
    transform: "translate(33.643 5.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3453",
    "data-name": "Group 3453",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1457",
    "data-name": "Rectangle 1457",
    width: 7.198,
    height: 19.979,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-3)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3456",
    "data-name": "Group 3456",
    transform: "translate(31.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3455",
    "data-name": "Group 3455",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1458",
    "data-name": "Rectangle 1458",
    width: 11.81,
    height: 4.767,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-4)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3458",
    "data-name": "Group 3458",
    transform: "translate(47.294 3.108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3457",
    "data-name": "Group 3457",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1459",
    "data-name": "Rectangle 1459",
    width: 106.266,
    height: 30.411,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-5)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3460",
    "data-name": "Group 3460",
    transform: "translate(138.309 3.456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3459",
    "data-name": "Group 3459",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1460",
    "data-name": "Rectangle 1460",
    width: 6.016,
    height: 6.015,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-6)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3462",
    "data-name": "Group 3462",
    transform: "translate(0.155 36.255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3461",
    "data-name": "Group 3461",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1461",
    "data-name": "Rectangle 1461",
    width: 14.875,
    height: 15.641,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-7)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3464",
    "data-name": "Group 3464",
    transform: "translate(16.776 36.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3463",
    "data-name": "Group 3463",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1462",
    "data-name": "Rectangle 1462",
    width: 15.324,
    height: 15.162,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-8)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3466",
    "data-name": "Group 3466",
    transform: "translate(32.955 36.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3465",
    "data-name": "Group 3465",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1463",
    "data-name": "Rectangle 1463",
    width: 15.415,
    height: 15.322,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-9)"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3468",
    "data-name": "Group 3468",
    transform: "translate(49.121 36.255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3467",
    "data-name": "Group 3467",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1464",
    "data-name": "Rectangle 1464",
    width: 14.067,
    height: 15.641,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-10)"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3470",
    "data-name": "Group 3470",
    transform: "translate(64.128 36.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3469",
    "data-name": "Group 3469",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1465",
    "data-name": "Rectangle 1465",
    width: 11.914,
    height: 15.162,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-11)"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3472",
    "data-name": "Group 3472",
    transform: "translate(77.429 36.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3471",
    "data-name": "Group 3471",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1466",
    "data-name": "Rectangle 1466",
    width: 11.913,
    height: 15.162,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-12)"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3474",
    "data-name": "Group 3474",
    transform: "translate(90.729 36.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3473",
    "data-name": "Group 3473",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1467",
    "data-name": "Rectangle 1467",
    width: 11.379,
    height: 15.162,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-13)"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3476",
    "data-name": "Group 3476",
    transform: "translate(106.843 36.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3475",
    "data-name": "Group 3475",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1468",
    "data-name": "Rectangle 1468",
    width: 15.414,
    height: 15.322,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-14)"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3478",
    "data-name": "Group 3478",
    transform: "translate(123.905 36.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3477",
    "data-name": "Group 3477",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1469",
    "data-name": "Rectangle 1469",
    width: 14.516,
    height: 15.162,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-15)"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3480",
    "data-name": "Group 3480",
    transform: "translate(139.45 36.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3479",
    "data-name": "Group 3479",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1470",
    "data-name": "Rectangle 1470",
    width: 14.516,
    height: 15.162,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-16)"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3482",
    "data-name": "Group 3482",
    transform: "translate(91.204 1.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3481",
    "data-name": "Group 3481",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1471",
    "data-name": "Rectangle 1471",
    width: 7.287,
    height: 7.287,
    transform: "translate(-2.537 3.106) rotate(-50.753)",
    fill: "url(#linear-gradient-17)"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3484",
    "data-name": "Group 3484",
    transform: "translate(88.02 9.838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3483",
    "data-name": "Group 3483",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1472",
    "data-name": "Rectangle 1472",
    width: 4.48,
    height: 4.48,
    transform: "matrix(0.633, -0.774, 0.774, 0.633, -1.56, 1.909)",
    fill: "url(#linear-gradient-18)"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3486",
    "data-name": "Group 3486",
    transform: "translate(87.074 4.901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3485",
    "data-name": "Group 3485",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1473",
    "data-name": "Rectangle 1473",
    width: 2.66,
    height: 2.661,
    transform: "matrix(0.633, -0.774, 0.774, 0.633, -0.926, 1.134)",
    fill: "url(#linear-gradient-19)"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3488",
    "data-name": "Group 3488",
    transform: "translate(66.406 9.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3487",
    "data-name": "Group 3487",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1474",
    "data-name": "Rectangle 1474",
    width: 47.222,
    height: 52.574,
    transform: "matrix(0.633, -0.774, 0.774, 0.633, -8.127, 9.948)",
    fill: "url(#linear-gradient-20)"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3490",
    "data-name": "Group 3490",
    transform: "translate(73.003 27.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3489",
    "data-name": "Group 3489",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1475",
    "data-name": "Rectangle 1475",
    width: 12.427,
    height: 13.273,
    transform: "matrix(0.633, -0.774, 0.774, 0.633, -3.09, 3.644)",
    fill: "url(#linear-gradient-21)"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3492",
    "data-name": "Group 3492",
    transform: "translate(90.729 36.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3491",
    "data-name": "Group 3491",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1476",
    "data-name": "Rectangle 1476",
    width: 3.298,
    height: 3.455,
    transform: "matrix(0.633, -0.774, 0.774, 0.633, -0.903, 1.106)",
    fill: "url(#linear-gradient-22)"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3494",
    "data-name": "Group 3494",
    transform: "translate(50.607 23.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3493",
    "data-name": "Group 3493",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1477",
    "data-name": "Rectangle 1477",
    width: 18.08,
    height: 18.84,
    transform: "matrix(0.633, -0.774, 0.774, 0.633, -5.115, 6.261)",
    fill: "url(#linear-gradient-23)"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3496",
    "data-name": "Group 3496",
    transform: "translate(26.557 44.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3495",
    "data-name": "Group 3495",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1478",
    "data-name": "Rectangle 1478",
    width: 9.071,
    height: 8.837,
    transform: "translate(-3.521 4.31) rotate(-50.753)",
    fill: "url(#linear-gradient-24)"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3498",
    "data-name": "Group 3498",
    transform: "translate(32.955 36.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3497",
    "data-name": "Group 3497",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1479",
    "data-name": "Rectangle 1479",
    width: 21.578,
    height: 21.598,
    transform: "translate(-7.482 9.159) rotate(-50.753)",
    fill: "url(#linear-gradient-25)"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3500",
    "data-name": "Group 3500",
    transform: "translate(49.124 36.252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3499",
    "data-name": "Group 3499",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1480",
    "data-name": "Rectangle 1480",
    width: 21.012,
    height: 20.789,
    transform: "translate(-7.664 9.381) rotate(-50.753)",
    fill: "url(#linear-gradient-26)"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3502",
    "data-name": "Group 3502",
    transform: "translate(77.429 36.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3501",
    "data-name": "Group 3501",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1481",
    "data-name": "Rectangle 1481",
    width: 15.27,
    height: 15.497,
    transform: "matrix(0.633, -0.774, 0.774, 0.633, -4.965, 6.078)",
    fill: "url(#linear-gradient-27)"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3504",
    "data-name": "Group 3504",
    transform: "translate(64.128 36.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3503",
    "data-name": "Group 3503",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1482",
    "data-name": "Rectangle 1482",
    width: 19.279,
    height: 18.819,
    transform: "translate(-7.428 9.093) rotate(-50.753)",
    fill: "url(#linear-gradient-28)"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3506",
    "data-name": "Group 3506",
    transform: "translate(26.563 54.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3505",
    "data-name": "Group 3505",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1483",
    "data-name": "Rectangle 1483",
    width: 42.639,
    height: 1.325,
    transform: "translate(-0.001 -0.017)",
    fill: "url(#linear-gradient-29)"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3508",
    "data-name": "Group 3508",
    transform: "translate(26.558 56.869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3507",
    "data-name": "Group 3507",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1485",
    "data-name": "Rectangle 1485",
    width: 42.641,
    height: 32,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrk14);
export default __webpack_public_path__ + "static/media/wrk-14.b7fa8eec06611a9324f1fd531c934b53.svg";
export { ForwardRef as ReactComponent };